import * as request from '@eika-infrastruktur/request';
import { Dispatch } from 'redux';
import { SERVICE_PATH } from './index';
import { 
    StartActivationParam, StartActivationResult,
    SendPasswordParam, SendPasswordResult,
    ActivateOrderParam, ActivateOrderResult
} from '../generated-types';

const SET_ACTIVATE_ORDER = 'SET_ACTIVATE_ORDER';
const SET_ACTIVATION = 'SET_ACTIVATION';
const SET_SEND_PASSWORD = 'SET_SEND_PASSWORD';

/******************************************************************************
******************************************************************************/
export const getActivation = (data: StartActivationParam) => async (dispatch: Dispatch) => {
    let result: any = null;

    const url = `${SERVICE_PATH}/activation/start`;

    try {
        result = await request.post(url, data).then((response: any) => {
            return response || null;
        }).catch(() =>  null );
    } catch (error) {
        result = null;
    }

    // kiet test
    // result = { success: true, result: 'blabla', reference: '--REFERENCE--', phoneNumberHint: '*** ** 334' };
    // result = { success: false, result: 'NO_BANKID_OR_OTP_VERIFICATION_FAILED' };

    dispatch({ type: SET_ACTIVATION, result });
};

export const setActivation = ( result?: null | StartActivationResult ) => async (dispatch: Dispatch) => {
    dispatch({ type: SET_ACTIVATION, result });
};

/******************************************************************************
******************************************************************************/
export const postSendPassword = ( data: SendPasswordParam ) => async (dispatch: Dispatch) => {
    let result: any = null;

    const url = `${SERVICE_PATH}/activation/password`;

    try {
        result = await request.post(url, data).then((response: any) => {
            return response || null;
        }).catch(() =>  null );
    } catch (error) {
        result = null;
    }

    // kiet test
    // result = { success: false, result: 'xxx' };
    // result = { success: true, result: 'xxx' };

    return dispatch({ type: SET_SEND_PASSWORD, result });
};

export const setSendPassword = ( result?: null | SendPasswordResult ) => async (dispatch: Dispatch) => {
    dispatch({ type: SET_SEND_PASSWORD, result });
};

/******************************************************************************
******************************************************************************/
export const postActivateOrder = ( data: ActivateOrderParam ) => async (dispatch: Dispatch) => {
    let result: any = null;

    const url = `${SERVICE_PATH}/activation/activateOrder`;

    try {
        result = await request.post(url, data).then((response: any) => {
            return response || null;
        }).catch(() =>  null );
    } catch (error) {
        result = null;
    }

    // kiet test
    // result = { success: false, result: 'WRONG_PASSWORD' };
    // result = { success: true, result: 'xx' };

    return dispatch({ type: SET_ACTIVATE_ORDER, result });
};

export const setActivateOrder = ( result?: null | ActivateOrderResult ) => async (dispatch: Dispatch) => {
    dispatch({ type: SET_ACTIVATE_ORDER, result });
};

/******************************************************************************
******************************************************************************/
export interface ActivationReducer {
    activation?: null | StartActivationResult;
    passwordSending?: null | SendPasswordResult;
    activated?: null | ActivateOrderResult;
};

const initialState: ActivationReducer = {
    activation: undefined,
    activated: undefined,
    passwordSending: undefined,
};

export default (state = initialState, action: any = {}) => {
    switch (action.type) {
        case SET_ACTIVATION:
            return {...state, activation: action.result };
        case SET_ACTIVATE_ORDER:
            return {...state, activated: action.result };
        case SET_SEND_PASSWORD:
            return {...state, passwordSending: action.result };
        default:
            return state;
    }
};
